import { render } from "./MoveToModal.vue?vue&type=template&id=14d56c1d"
import script from "./MoveToModal.vue?vue&type=script&lang=js"
export * from "./MoveToModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__